import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Row, Col, Table, Card, CardBody } from "reactstrap"
import CardItem from "./CardItem"
import Paginator from "components/Common/Paginator/Paginator"
import FilterModal from "./FilterModal"
import FilterIcon from "assets/images/filter.png"
import StatusButton from "./StatusButton"
import moment from "moment"
import "./styles.scss"
import { useSelector } from "react-redux"
import DealService from "services/SalesDeveloper/DealService"

const DealsPage = (props) => {
    const dealService = new DealService()
    const AuthData = useSelector(state => state.Auth)
    const isExist = (data) => AuthData.permissions[data]
    const [status, setStatus] = useState('All')
    const [modal, setModal] = useState(false)
    const [searchWord, setSearchWord] = useState("")
    const [list, setList] = useState([])
    const [filtersParams, setFilterParams] = useState(null)
    const [shouldGetData, setShouldGetData] = useState(false)
    const [filterData, setFilterData] = useState({
        unit_type_ids: null,
        min_price: "",
        max_price: "",
        from_date: "",
        to_date: "",
        compound_ids: null
    })
    const [pageOptions, setPageOptions] = useState({
        sizePerPage: 10,
        totalSize: 1,
    })

    const toggle = () => {
        setModal(!modal)
    }

    const OnSearchChange = (e) => {
        const search = e.target.value
        setSearchWord(search)
    }

    useEffect(() => {
        // debounce solution to reduce request data from api
        const timeoutId = setTimeout(() => {
            const params = {}
            if (status != 'All') params['status'] = status
            if (searchWord.trim().length) params['keyword'] = searchWord

            if (filterData) {
                if (filterData ?.unit_type_ids ?.length) params['unit_type_ids'] = filterData ?.unit_type_ids ?.map(item => item.value).join()
                if (filterData ?.compound_ids ?.length) params['compound'] = filterData ?.compound_ids ?.map(item => item.value).join()
                if (filterData ?.min_price) params['min_price'] = filterData ?.min_price
                if (filterData ?.max_price) params['max_price'] = filterData ?.max_price
                if (filterData ?.from_date ?.length && filterData ?.to_date ?.length) {
                    params['date_range'] = `${filterData.from_date},${filterData.to_date}`
               } else if (filterData ?.from_date ?.length) {
                   params['date_range'] = `${filterData.from_date},${moment().format(`YYYY-MM-DD`)}`
               } else if (filterData ?.to_date ?.length) {
                   params['date_range'] = `0,${filterData.to_date}`
               }
                 
            }
            setFilterParams({ ...params })
        }, 1000)

        return () => clearTimeout(timeoutId)

    }, [status, searchWord,
        filterData.unit_type_ids,
        filterData.compound_ids,
        filterData.to_date,
        filterData.from_date,
        filterData.min_price,
        filterData.max_price
    ])

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Deals</title>
                </MetaTags>
                <Container fluid>
                    <Row className="mb-1">
                        <Col md={6}>
                            <h4>Manage Deals</h4>
                        </Col>
                    </Row>
                    <Row className="mb-2">
                        <Col md={6}>
                            <div className="form-group has-search">
                                <span className="fa fa-search form-control-feedback"></span>
                                <input type="text" className="form-control" placeholder="Search by Client Name, Unit Code, I.D" onChange={(e) => OnSearchChange(e)}
                                    value={searchWord} />
                            </div>
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col md={10} className="mb-3">
                            <StatusButton statusValue={status} status={"All"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Uncontacted"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Contacted"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Open"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Closed"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Won"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Lost"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Unreachable"} setStatus={setStatus} />
                            <StatusButton statusValue={status} status={"Pending"} setStatus={setStatus} />
                        </Col>
                        <Col sm={2} className="mb-3 d-flex flex-row-reverse">

                            <button className="btn btnUpload btnHeight px-4" style={{ margin: "0" }} onClick={() => {
                                setModal(!modal)
                            }}> <img src={FilterIcon} style={{ marginRight: "5px" }} />Filter</button>
                        </Col>
                    </Row>
                    <div className="m-0">
                        <Card className="w-100 mt-0">
                            <CardBody>
                                <div className="py-3">
                                    <div>
                                        <div className="table-responsive-crm" >
                                            <Table>
                                                <thead>
                                                    <tr className="bgHeaderTable">
                                                        <th className="font-size-14">I.D</th>
                                                        <th className="font-size-14">Client Name</th>
                                                        <th className="font-size-14">Sales Rep</th>
                                                        <th className="font-size-14">Creation Date</th>
                                                        <th className="font-size-14">Unit Type</th>
                                                        <th className="font-size-14">Compound</th>
                                                        <th className="font-size-14">Unit Price</th>
                                                        <th className="font-size-14">Status</th>
                                                        <th className="font-size-14"> </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {list.map((item, index) => {
                                                        return (
                                                            <CardItem
                                                                key={index}
                                                                item={item}
                                                                history={props.history}
                                                                setShouldGetData={setShouldGetData}
                                                            />
                                                        )
                                                    })}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        <Row className="d-flex justify-content-end">
                            <Col className="d-flex justify-content-between" md={12} sm={12}>
                                <Paginator
                                    service={dealService}
                                    pageOptions={pageOptions}
                                    setData={(data) => setList([...data])}
                                    setPageOptions={setPageOptions}
                                    filtersParams={filtersParams}
                                    shouldGetData={shouldGetData}
                                    setShouldGetData={setShouldGetData}
                                />
                            </Col>
                        </Row >
                       {modal ? <FilterModal
                            toggle={toggle}
                            modal={modal}
                            onSumbit={(data) => setFilterData(data)}
                            filterData={filterData}
                        />:null}
                    </div>
                </Container>
            </div>
        </React.Fragment>
    )
}
export default DealsPage